import {FuseNavigation} from '@fuse/types';

export const adminFeature: FuseNavigation[] = [
    {
        id: 'features',
        title: 'Features',
        type: 'group',
        children: [
            {
                id: 'ai-feature',
                title: 'AI Feature V1 (ChatMagic)',
                type: 'item',
                children: []
            },
            {
                id: 'claudy-feature',
                title: 'Claudy',
                type: 'item',
                children: []
            },
            {
                id: 'claudy-query',
                title: 'Claudy: Query data',
                type: 'item',
                children: []
            },
            {
                id: 'claudy-edit',
                title: 'Claudy: Create / edit',
                type: 'item',
                children: []
            },
            {
                id: 'claudy-delete',
                title: 'Claudy: Delete',
                type: 'item',
                children: []
            },
            {
                id: 'claudy-actions',
                title: 'Claudy: Actions (mail, workflows, API calls)',
                type: 'item',
                children: []
            },
            {
                id: 'claudy-mobile',
                title: 'Claudy: Use in the app',
                type: 'item',
                children: []
            },
            {
                id: 'crossServer',
                title: 'Cross Server Events',
                type: 'item',
                children: []
            },
            {
                id: 'driver-app-access',
                title: 'Driver App Access',
                type: 'item',
                children: []
            },
            {
                id: 'invoice-approveAndPost-toggle',
                title: 'Invoice Approve And Post',
                type: 'group',
                children: []
            },
            {
                id: 'invoice-cancelInvoiced-toggle',
                title: 'Cancel Invoiced Invoices',
                type: 'group',
                children: []
            },
            {
                id: 'driver-emergencyContact-access',
                title: 'Driver Emergency Contact',
                type: 'group',
                children: []
            },
            {
                id: 'organisations-feature',
                title: 'Organisations',
                type: 'group',
                children: [
                    {
                        id: 'organisations-delete-toggle',
                        title: 'Toggle Delete Access',
                        type: 'item',
                        children: []
                    },
                    {
                        id: 'organisations-edit-toggle',
                        title: 'Toggle Edit Access',
                        type: 'item',
                        children: []
                    }
                ]
            },
            {
                id: 'order-feature',
                title: 'Order',
                type: 'group',
                children: [
                    {
                        id: 'haulierOrders-edit-toggle',
                        title: 'Delivered Order Edit Access',
                        type: 'item',
                        children: []
                    }
                ]
            },
            {
                id: 'driver-strikes-feature',
                title: 'Driver Strikes',
                type: 'group',
                children: [
                    {
                        id: 'driver-strikes-remove-toggle',
                        title: 'Toggle Remove Driver Strike',
                        type: 'item',
                        children: []
                    },
                    {
                        id: 'driver-strikes-add-toggle',
                        title: 'Toggle Add Driver Strike',
                        type: 'item',
                        children: []
                    },
                    {
                        id: 'driver-strikes-view-toggle',
                        title: 'Toggle View Driver Strike',
                        type: 'item',
                        children: []
                    }
                ]
            }
        ]
    }
];
